import { Box, Button, Stack } from "@mui/material";
import { useEffect } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useImmer } from "use-immer";
import { postComponents, updateComponents } from "../../../../../api/services";
import Quill from "../../../../../components/Quill";

const TextContentForm = ({ data, close }: any) => {
  const queryClient = useQueryClient();
  const { id: subjectId } = useParams();
  const [search] = useSearchParams();
  const topicId = search.get("topicId");
  const chapterId = search.get("chapterId");
  const sectionId = search.get("sectionId");

  const [state, setState] = useImmer<{
    description: string;
  }>({
    description: "",
  });

  useEffect(() => {
    setState({
      description: data?.description || "",
    });
  }, [data]);

  const { mutate } = useMutation(postComponents, {
    onSuccess: (res: any) => {
      toast.success(res?.data?.message);
      queryClient.invalidateQueries("topic-id");
      close();
    },
    onError: (err: any) => {
      toast.error(err?.response?.data?.message);
    },
  });

  const { mutate: updateMutate } = useMutation(updateComponents, {
    onSuccess: (res: any) => {
      toast.success("Test Updated Successfully");
      queryClient.invalidateQueries("topic-id");
      close();
    },
    onError: (err: any) => {
      toast.error(err?.response?.data?.message);
    },
  });

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const res = {
      subjectId,
      chapterId,
      topicId,
      sectionId,
      type: "TEXT",
      description: state?.description,
    };
    if (data?._id) {
      updateMutate({ id: data?._id, body: res });
    } else {
      mutate(res);
    }
  };

  const handleChange = (value: any) => {
    setState((s: any) => {
      s.description = value;
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <Stack gap={2}>
        <Quill
          data={state?.description}
          handleChange={(value) => handleChange(value)}
        />
        {/* <TextField
          fullWidth
          value={state?.duration}
          label="Duration (in minutes)"
          onChange={(e) => {
            setState((s) => {
              s.duration = e.target.value;
            });
          }}
          name="duration"
        /> */}
        <Box>
          <Button variant="contained" type="submit">
            Submit
          </Button>
        </Box>
      </Stack>
    </form>
  );
};

export default TextContentForm;
